import React, {
	Component,
} from "react";
import {
	View,
	StyleSheet,
	Dimensions,
} from "react-native";
import AtaContainer from "../AtaContainer";
import ATouchAwaySidebar from "../ATouchAwaySidebar";
import ATouchAwayInfoBar from "../ATouchAwayInfoBar";
import About from "../About";
import Reminder from "../Reminder";
import StyledText from "ae-base/Base/StyledText";
import StyledIcon from "ae-base/Base/StyledIcon";
import Style from "@aetonix/styles";
import WorkflowStatus from "../../Pages/Contactprofile/WorkflowStatus";
import MainScroll from "../../Layout/MainScroll";
import BraceletIcon from "../BraceletIconNew";
import { useResources } from "@aetonix/hooks";

var styles = StyleSheet.create({
	content: {
		flex: 1,
		flexDirection: "row",
	},
	rightContent: {
		flex: 1,
		justifyContent: "center",
	},
	title: {
		marginTop: Style.layout.marginSlim,
		marginBottom: Style.layout.marginSmall,
		alignItems: "center",
	},
	overall: {
		flexDirection: "column",
		padding: Style.layout.paddingMedium,
	},
	status: {
		marginTop: Style.layout.marginSlim,
		marginBottom: Style.layout.marginSmall,
		alignItems: "center",
	},
	icon: {
		margin: Style.layout.marginLarge,
		alignItems: "center",
	},
});

const MIN_DATE_WIDTH = 1000;

export default (props) => {
	const { dispatch, localize } = useResources();
	return <ATouchAwayStatus dispatch={dispatch} localize={localize} {...props} />;
};

class ATouchAwayStatus extends Component {
	constructor(props) {
		super(props);
		this.state = {
			sidebarWidth: 0,
		};
	}

	onSidebarLayoutChange = (event) => {
		let width = event.nativeEvent.layout.width;
		this.setState({
			sidebarWidth: width,
		});
	};

	render() {
		var model = this.props.model;
		var settings = model.settings;
		var options = model.options;
		var trunk = options.trunk;
		var reminder = model.reminders || {};
		var missed = model.missed;
		var pending = model.pendingactions;
		var status = model.status || {};
		var current_status = status.current_status;
		var workflowDefinitions = model.workflowdefinitions || {};
		var localize = this.props.localize;
		var atRisk = localize("workflowstatus.risk");
		var moderate = localize("workflowstatus.moderate");
		var stable = localize("workflowstatus.stable");
		var overview = localize("workflowstatus.overview");
		var resources = model.resources;
		var forms = model.forms;
		var allowedForms = settings.forms_sections || {};

		var renderTrunk = trunk ? <About options={options} /> : null;
		var renderReminder = reminder.active && !reminder.answered ? <Reminder reminder={reminder} /> : null;

		var iconName = current_status === 2 ? "thumbs-down" : current_status === 1 ? "bell" : current_status === 0 ? "thumbs-up" : null;

		var overallWorkflowStatus = current_status === 2 ? (
			<StyledText centered style={{color:"#C86060"}} large>{atRisk}</StyledText>
		) : current_status === 1 ? (
			<StyledText centered yellow large>{moderate}</StyledText>
		) : current_status === 0 ? (
			<StyledText centered green large>{stable}</StyledText>
		) : null;

		var iconColor = current_status === 2 ? Style.colors.statusRed :
			current_status === 1 ? Style.colors.yellow :
				current_status === 0 ? Style.colors.green : Style.colors.primary;

		var renderOverallStatus = current_status > -1 ? (
			<View style={styles.overall}>
				<View style={styles.title}>
					<StyledText tertiary  style={{color:"#4A959B"}} large>{overview}</StyledText>
					<View style={styles.icon}>
						<StyledIcon name={iconName} hugeHeading color={iconColor} />
						{overallWorkflowStatus}
					</View>
				</View>
			</View>
		) : null;

		var formsViewable = checkPermissions(forms, allowedForms);

		var renderInfoBar = <ATouchAwayInfoBar model={model} sidebarWidth={this.state.sidebarWidth} />;

		var personal = model.personal;
		var testModeEnabled = personal.testModeEnabled;

		var screenWidth = Dimensions.get("window").width;
		var footer = model.footer;
		var dateDisplay = [
			<View style={{ justifyContent: "center" }}>
				<StyledText bold contrast emphasized maxSize="smallHeading">
					{screenWidth < MIN_DATE_WIDTH ? footer.shortDate : footer.date}
				</StyledText>
			</View>];
		var testModeBanner = testModeEnabled ? (<View style={{ justifyContent: "center", flexGrow: 1, alignItems: "center"  }}>
			<StyledText bold emphasized maxSize="smallHeading" color={Style.colors.orange}>
				<StyledIcon color={Style.colors.orange} name={"fa-bug"} />
				{" "}
				{localize("testmode.title")}
			</StyledText>
		</View>) : null;
		var footerRight = testModeBanner || dateDisplay;
		var renderBraceletBar = (
			<View style={{ justifyContent: "space-between", flexDirection: "row", paddingRight: 12 }}>
				<BraceletIcon bracelet={model.bracelet} icon={"aeto-watch"} />
				{footerRight}
			</View>
		);

		return (
			<AtaContainer>
				<View style={{height: "100%"}}>
					{renderInfoBar}
					<View style={styles.content}>
						<View onLayout={this.onSidebarLayoutChange}>
							<ATouchAwaySidebar
								formsViewable={formsViewable}
								workflowActions={pending}
								missed={missed}
								settings={settings}
								page={"status"}
								resources={resources}
								status={status}
								model={model}
							/>
						</View>
						<MainScroll atouchaway style={{backgroundColor: "#131618"}}>
							<View style={styles.rightContent}>
								{renderOverallStatus}
								<View style={styles.status}>
									<WorkflowStatus status={status} workflowDefinitions={workflowDefinitions} large atouchaway />
								</View>
							</View>
						</MainScroll>
					</View>
					{renderTrunk}
					{renderReminder}
					{renderBraceletBar}
				</View>
			</AtaContainer>
		);
	}
}

function checkPermissions(list, permissions){
	return Object.keys(list).reduce(function(acc, element){
		if(permissions[element])
			acc[element] = list[element];
		return acc;
	}, {});
}
